import React from 'react';
import { getPoolsServiceLocationBase } from '../../common/api/data';
import { useState, useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import Multiselect from 'multiselect-react-dropdown';  // documentation - https://www.npmjs.com/package/multiselect-react-dropdown
import { ModalUpdatePoolSchedule } from './modalupdatepoolschedule';

import MagicTable from "../../common/ui/magictable";

import {
	MapContainer,
	TileLayer,
	Marker,
	Popup,
	ScaleControl,
	Tooltip,
	//useMap,
} from 'react-leaflet';

import { Icon } from 'leaflet';

interface Pool {
	_id: string,
	objectId: number,
	name: string,
	type: string,
	status: string,
	baby_kids_areas: string,
	hot_tub: string,
	volleyball_court: string,
	basketball_hoop: string,
	climbing_wall: string,
	slide: string,
	latitude: number,
	longitude: number,
}

interface PoolHome {
	_id: string,
	objectId: number,
	name: string,
	type: string,
	latitude: number,
	longitude: number,
}

interface SelectOption {
	id: string,
	label: string,
}

//import { parseISO, format } from 'date-fns'

//const formatDate = (dateString) => {
//	return dateString === undefined ? 'Loading...' : format(parseISO(dateString), "MM/dd/yyyy h:mm:ss a");
//}

const houseIcon = new Icon({
	iconUrl: 'assets/house.png',
	iconSize: [27, 27], // size of the icon
	iconAnchor: [14, 14], // point of the icon which will correspond to marker's location
	popupAnchor: [-3, -76] // point from which the popup should open relative to the iconAnchor

});

/*const formatPrice = (n : number) => {
	var ds = ''
	for (let i = 1; i <= n; i++) {
		ds = ds + '$'
	}
	return ds
}*/

/*const formatOpen = (n : string) => {
	return n === '0' ? 'Closed' : 'Open'
}*/

const chooseIcon = (type : string, status : string) => {
	let arrowColor = 'blue';
	if (status === undefined || status === 'no' || status === 'false') {
		arrowColor = 'gray';
	} else {
		if (type === 'indoor pool') {
			arrowColor = 'green';
		}
	}
	var icon = new Icon({
		iconUrl: `assets/${arrowColor}_arrow.png`,
		iconSize: [15, 41], // size of the icon
		iconAnchor: [8, 41], // point of the icon which will correspond to marker's location
		//popupAnchor: [-3, -76] // point from which the popup should open relative to the iconAnchor
	});
	return icon;
};

const has = (list : SelectOption[], element : string) => {
	//console.log(list);
	//console.log(element);
	//console.log(typeof element);
	const count = list
		.filter( s => (s.label === element) || (s.label === 'no' && (element === undefined || element === 'false') ) );
		//.length > 0;
	//console.log(count.length);
	return count.length > 0;
};

const Pools = () => {
	let p = {} as Pool;
	const [data, setData] = useState<Pool[]>([]);
	const [rhome, setRhome] = useState<PoolHome>(p);
	const [queryParams] = useSearchParams();
	const [loading, setLoading] = useState(true);

	const [selectedStatuses, setSelectedStatuses] = useState<SelectOption[]>([]);
	const [selectedTypes, setSelectedTypes] = useState<SelectOption[]>([]);
	const [selectedHotTubs, setSelectedHotTubs] = useState<SelectOption[]>([]);
	const [selectedVolleyballCourts, setSelectedVolleyballCourts] = useState<SelectOption[]>([]);
	const [selectedBasketballHoops, setSelectedBasketballHoops] = useState<SelectOption[]>([]);
	const [selectedClimbingWalls, setSelectedClimbingWalls] = useState<SelectOption[]>([]);
	const [selectedSlides, setSelectedSlides] = useState<SelectOption[]>([]);
	const [selectedBabyAreas, setSelectedBabyAreas] = useState<SelectOption[]>([]);

	const typeOptions = [
		{ id: '1', label: 'outdoor pool' },
		{ id: '2', label: 'indoor pool' },
	];

	const babyAreaOptions = [
		{ id: '1', label: 'good' },
		{ id: '2', label: 'medium' },
		{ id: '3', label: 'poor' },
		{ id: '4', label: 'unknown' },
	];

	const booleanOptions = [
		{ id: '1', label: 'true' },
		{ id: '2', label: 'no' },
	];

	const pageLoadFunction = async () => {
		loadDashboardData();
		setSelectedStatuses(booleanOptions);
		setSelectedTypes(typeOptions);
		setSelectedHotTubs(booleanOptions);
		setSelectedVolleyballCourts(booleanOptions);
		setSelectedBasketballHoops(booleanOptions);
		setSelectedClimbingWalls(booleanOptions);
		setSelectedSlides(booleanOptions);
		setSelectedBabyAreas(babyAreaOptions);
	};

	useEffect(() => {
		console.log('mounting pools component');
		pageLoadFunction();
	}, []);

	const loadDashboardData = () => {
		// console.log('this.queryParams');
		console.log(`queryParams: ${queryParams.get('tag')}`);
		//alert('loadDataShortWay')
		//console.log('loadDataShortWay');
		//const token = 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJqYXZhaW51c2UiLCJpYXQiOjE3NjYwMzQ3NzYsImV4cCI6MTc2NjYzOTU3Nn0.hkMkUHL2trSWVbzZ7weh4Vvs3pizWRcAi-b0rl2imEhVhhHNJ7F3xlO60UY2Aa7GNNl8X9g5d23OIC_0JwE2Gw';
		var getRequestOptions = {
			method: 'GET',
			//headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
		};
		fetch(`${getPoolsServiceLocationBase()}/${queryParams.get('tag')}`, getRequestOptions).then(r => {
			r.json().then(j => {
				//console.log('json');
				//console.log(j);
				// set j to your page variable or do whatever with it
				for (let i = 0; i < j.pools.length; i++) {
					//console.log(j[i]);
					//j.pools[i].price = formatPrice(j.pools[i].price)
					//j.pools[i].available = formatOpen(j.pools[i].available)
				}
				setRhome(j.home);
				setData(j.pools);
				setLoading(false);
				//console.log(rhome);
				//console.log(data);
			})
			.catch(f => {
				console.log('json error');
				console.log(f);
			});
		})
		.catch(e => {
			console.log('fetch error');
			console.log(e);
		});
	};

	const columns = useMemo(
		() => [
			{
                Header: () => (<div className={"names"}>Name</div>),
                Cell: (row : any) => (<div className={"names"}>{row.value}</div>),
				accessor: "name",
			},
			{
				Header: () => (<div className={"names"}>Open</div>),
				Cell: (row : any) => (<div className={"names"}>{row.value}</div>),
				accessor: "status",
			},
			{
				Header: () => (<div className={"names"}>Type</div>),
				Cell: (row : any) => (<div className={"names"}>{row.value}</div>),
				accessor: "type",
			},
			{
                Header: () => (<div className={"names"}>Hot<br />Tub</div>),
                Cell: (row : any) => (<div className={"names"}>{row.value}</div>),
				accessor: "hot_tub",
			},
			{
                Header: () => (<div className={"names"}>Vball<br />Court</div>),
                Cell: (row : any) => (<div className={"names"}>{row.value}</div>),
				accessor: "volleyball_court",
			},
			{
				Header: () => (<div className={"names"}>Bball<br />Hoop</div>),
				Cell: (row : any) => (<div className={"names"}>{row.value}</div>),
				accessor: "basketball_hoop",
			},
			{
				Header: () => (<div className={"names"}>Baby<br />Area</div>),
				Cell: (row : any) => (<div className={"names"}>{row.value}</div>),
				accessor: "baby_kids_areas",
			},
			{
				Header: () => (<div className={"names"}>Climb<br />Wall</div>),
				Cell: (row : any) => (<div className={"names"}>{row.value}</div>),
				accessor: "climbing_wall",
			},
			{
				Header: () => (<div className={"names"}>Schedule</div>),
				Cell: (row : any) => (<button onClick={() => update(row.value)}>Update</button>),
				accessor: "_id",
			},
		],
		[]
	);

	const renderStatusPicker = () => {
		return (
			<div className={"filterSmall dropdown"}>
				<Multiselect
					isObject={true}
					options={booleanOptions}
					showCheckbox={true}
					onSelect={(e : []) => {setSelectedStatuses(e);} }
					onRemove={(e : []) => {setSelectedStatuses(e);} }
					selectedValues={selectedStatuses}
					displayValue='label'
					avoidHighlightFirstOption={true}
					hideSelectedList={true}
					keepSearchTerm={false}
					showArrow={true}
					placeholder='Open'
				/>
			</div>
		);
	};

	const renderTypePicker = () => {
		return (
			<div className={"filterLarger dropdown"}>
				<Multiselect
					isObject={true}
					options={typeOptions}
					showCheckbox={true}
					onSelect={(e : []) => {setSelectedTypes(e);} }
					onRemove={(e : []) => {setSelectedTypes(e);} }
					selectedValues={selectedTypes}
					displayValue='label'
					avoidHighlightFirstOption={true}
					hideSelectedList={true}
					keepSearchTerm={false}
					showArrow={true}
					placeholder='Out/Indoor'
				/>
			</div>
		);
	};

	const renderBabyAreaPicker = () => {
		return (
			<div className={"filterLarge dropdown"}>
				<Multiselect
					isObject={true}
					options={babyAreaOptions}
					showCheckbox={true}
					onSelect={(e : []) => {setSelectedBabyAreas(e);} }
					onRemove={(e : []) => {setSelectedBabyAreas(e);} }
					selectedValues={selectedBabyAreas}
					displayValue='label'
					avoidHighlightFirstOption={true}
					hideSelectedList={true}
					keepSearchTerm={false}
					showArrow={true}
					placeholder='Baby Area'
				/>
			</div>
		);
	};

	const renderHotTubPicker = () => {
		return (
			<div className={"filter dropdown"}>
				<Multiselect
					isObject={true}
					options={booleanOptions}
					showCheckbox={true}
					onSelect={(e : []) => {setSelectedHotTubs(e);} }
					onRemove={(e : []) => {setSelectedHotTubs(e);} }
					selectedValues={selectedHotTubs}
					displayValue='label'
					avoidHighlightFirstOption={true}
					hideSelectedList={true}
					keepSearchTerm={false}
					showArrow={true}
					placeholder='Hot Tub'
				/>
			</div>
		);
	};

	const renderVolleyballCourtPicker = () => {
		return (
			<div className={"filter dropdown"}>
				<Multiselect
					isObject={true}
					options={booleanOptions}
					showCheckbox={true}
					onSelect={(e : []) => {setSelectedVolleyballCourts(e);} }
					onRemove={(e : []) => {setSelectedVolleyballCourts(e);} }
					selectedValues={selectedVolleyballCourts}
					displayValue='label'
					avoidHighlightFirstOption={true}
					hideSelectedList={true}
					keepSearchTerm={false}
					showArrow={true}
					placeholder='VB Court'
				/>
			</div>
		);
	};

	const renderBasketballHoopPicker = () => {
		return (
			<div className={"filter dropdown"}>
				<Multiselect
					isObject={true}
					options={booleanOptions}
					showCheckbox={true}
					onSelect={(e : []) => {setSelectedBasketballHoops(e);} }
					onRemove={(e : []) => {setSelectedBasketballHoops(e);} }
					selectedValues={selectedBasketballHoops}
					displayValue='label'
					avoidHighlightFirstOption={true}
					hideSelectedList={true}
					keepSearchTerm={false}
					showArrow={true}
					placeholder='BB Hoop'
				/>
			</div>
		);
	};

	const renderClimbingWallPicker = () => {
		return (
			<div className={"filter dropdown"}>
				<Multiselect
					isObject={true}
					options={booleanOptions}
					showCheckbox={true}
					onSelect={(e : []) => {setSelectedClimbingWalls(e);} }
					onRemove={(e : []) => {setSelectedClimbingWalls(e);} }
					selectedValues={selectedClimbingWalls}
					displayValue='label'
					avoidHighlightFirstOption={true}
					hideSelectedList={true}
					keepSearchTerm={false}
					showArrow={true}
					placeholder='Climb Wall'
				/>
			</div>
		);
	};

	const renderSlidePicker = () => {
		return (
			<div className={"filterSmall dropdown"}>
				<Multiselect
					isObject={true}
					options={booleanOptions}
					showCheckbox={true}
					onSelect={(e : []) => {setSelectedSlides(e);} }
					onRemove={(e : []) => {setSelectedSlides(e);} }
					selectedValues={selectedSlides}
					displayValue='label'
					avoidHighlightFirstOption={true}
					hideSelectedList={true}
					keepSearchTerm={false}
					showArrow={true}
					placeholder='Slide'
				/>
			</div>
		);
	};

	const renderMap = () => {
		var rh : PoolHome = rhome;
		return (
			<span id="map">
				<MapContainer center={[rh.latitude, rh.longitude]} zoom={13} scrollWheelZoom={true}>
					<TileLayer
						attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
						url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
					/>
					{data
						.filter((r : Pool) => has(selectedStatuses, r.status) )
						.filter((r : Pool) => has(selectedTypes, r.type) )
						.filter((r : Pool) => has(selectedHotTubs, r.hot_tub) )
						.filter((r : Pool) => has(selectedVolleyballCourts, r.volleyball_court) )
						.filter((r : Pool) => has(selectedBasketballHoops, r.basketball_hoop) )
						.filter((r : Pool) => has(selectedClimbingWalls, r.climbing_wall) )
						.filter((r : Pool) => has(selectedSlides, r.slide) )
						.filter((r : Pool) => has(selectedBabyAreas, r.baby_kids_areas) )
						.map((r : Pool) => (
							<span key={r._id}>
								<Marker icon={chooseIcon(r.type, r.status)} position={[r.latitude, r.longitude]}>
									<Popup>
										<strong><u>{r.name}</u></strong> - <span>{r.status === 'true' ? 'Open' : 'Closed'}</span><br />
										<div>Baby Area: {r.baby_kids_areas}</div>
										{r.hot_tub === 'true' ? <span>Hot Tub</span> : ''}
										{r.volleyball_court === 'true' ? <div>Volleyball Court</div> : ''}
										{r.basketball_hoop === 'true' ? <div>Basketball Hoop</div> : ''}
										{r.climbing_wall === 'true' ? <div>Climbing Wall</div> : ''}
										{r.slide === 'true' ? <div>Slide</div> : ''}
									</Popup>
									<Tooltip opacity={.7} permanent={true} sticky={true}>{r.name}</Tooltip>
								</Marker>
							</span>
						))
					}
					<Marker icon={houseIcon} position={[rh.latitude, rh.longitude]} alt={rh.name} title={rh.name} />
					<ScaleControl position="bottomright" metric={false} />
				</MapContainer>
			</span>
		);
	};

	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [updateSchedulePoolId, setUpdateSchedulePoolId] = useState('');
	//const [updateSchedulePoolName, setUpdateSchedulePoolName] = useState('');

	const update = (id: string) => {
		//alert('You are attempting to pick: ' + pickParam);
		setUpdateSchedulePoolId(id);
		// TODO - see if we can also do the name here
		//setUpdateSchedulePoolName(name);
		setModalIsOpen(true);
	};

	const handleModalNo = () => {
		setModalIsOpen(false);
	};

	const handleModalYes = (newScheduleText: string) => {
		setModalIsOpen(false);
		//let pickedPlayerName = 'abc'
		//alert('Save the pick: ' + pickedTeam);
		if (newScheduleText !== undefined) {
			sendScheduleUpdate(updateSchedulePoolId, newScheduleText);
		}
	};

	const sendScheduleUpdate = (id: string, text: string) => {
		console.log(`updating pool ${id} with text: ${text}`);
		var putRequestOptions = {
			method: 'PUT',
			headers: { 'Content-Type': 'text/plain', 'Authorization': 'Bearer token' },
			body: text,
		};
		fetch(`${getPoolsServiceLocationBase()}/parse/${id}`, putRequestOptions)//.then(r => {
		//fetch(getPokerServiceLocationBase() + '/assign?id=' + id + '&name=' + name)
		.then(res => {
			res.text();
			pageLoadFunction();
		})
		.then(text => {
			console.log(text);
		})
		.catch(console.log);
	};

	return (
		<div>
			<ModalUpdatePoolSchedule 
				ynmOpen={modalIsOpen} 
				ynmQuestionText={'Updating pool with id: ' + updateSchedulePoolId} 
				ynmNoText='Cancel' 
				ynmYesText='Submit' 
				ynmNoFunction={handleModalNo} 
				ynmYesFunction={handleModalYes} 
			/>
			<center><h1>Local Pools</h1></center>
			{
				loading ? 'Loading...' : <span>
					<table>
						<tbody>
							<tr>
								<td width='40%' className={"poolborder"}>
									<table className={"mainPoolsTable"} width='100%'>
										<tbody>
											<tr>
												<td style={{ verticalAlign: 'top' }}><MagicTable title={'Pools'} columns={columns} data={data} /></td>
											</tr>
										</tbody>
									</table>
								</td>
								<td width='60%' valign='top' className={"poolborder"}>
									<span className={"filters"}>
										{renderStatusPicker()}
										{renderTypePicker()}
										{renderHotTubPicker()}
										{renderVolleyballCourtPicker()}
										{renderBasketballHoopPicker()}
										{renderClimbingWallPicker()}
										{renderSlidePicker()}
										{renderBabyAreaPicker()}
									</span>
									{renderMap()}
								</td>
							</tr>
						</tbody>
					</table>
				</span>
			}
		</div>
	);

};

export default Pools;
